import React from "react";
import { Paper } from "@mui/material";

const LabsDetails = ({ lab, labName, labDesc, labAddress1, labAddress2, labAddress3, labAddress4, labCity, labState, labPostalCode, labContact, labPhoneNumber, labEmail, labPI }) => {
    let title,
        address1,
        address2,
        address3,
        address4,
        city,
        state,
        postalCode,
        contact,
        phoneNumber,
        email,
        pi;
    if (labName) {
        title = labDesc ? `${labName} (${labDesc})` : labName;
        address1 = labAddress1;
        address2 = labAddress2;
        address3 = labAddress3;
        address4 = labAddress4;
        city = labCity;
        state = labState;
        postalCode = labPostalCode;
        contact = labContact;
        phoneNumber = labPhoneNumber;
        email = labEmail;
        pi = labPI;
    } else if (lab) {
        title = (lab.LabDesc ? `${lab.LabName} (${lab.LabDesc})` : lab.LabName).trim();
        address1 = lab.ShippingAddress1;
        address2 = lab.ShippingAddress2;
        address3 = lab.ShippingAddress3;
        address4 = lab.ShippingAddress4;
        city = lab.ShippingCity;
        state = lab.ShippingState;
        postalCode = lab.ShippingPostalCode;
        contact = `${lab.ContactFirstName ? lab.ContactFirstName + " " : ""}${lab.ContactLastName ? lab.ContactLastName : ""}`.trim();
        phoneNumber = lab.PhoneNumber;
        email = lab.EmailAddress;
        pi = lab.PI;
    }

    return (
        <>
            {(labName || lab) && (
                <Paper
                    sx={{
                        paddingLeft: 4,
                        paddingRight: 4,
                        paddingTop: 3,
                        paddingBottom: 3,
                        marginTop: 1,
                        marginBottom: 1,
                        background: "#f2f3f6;",
                        boxShadow: "none",
                    }}
                >
                    <h2 className="labDetailTitle">{title}</h2>
                    <div className="dividerLine" />

                    <div className="labDetailFields">
                        <div className="labDetailFieldsLeft">
                            <div className="labDetailField">
                                <div className="labDetailFieldTitle">Contact</div>
                                <div className="labDetailFieldCopy">{contact}</div>
                            </div>
                            <div className="labDetailField">
                                <div className="labDetailFieldTitle">Phone Number</div>
                                <div className="labDetailFieldCopy">{phoneNumber}</div>
                            </div>
                            <div className="labDetailField">
                                <div className="labDetailFieldTitle">Email Address</div>
                                <div className="labDetailFieldCopy">{email}</div>
                            </div>
                            {pi && (
                                <div className="labDetailField">
                                    <div className="labDetailFieldTitle">PI</div>
                                    <div className="labDetailFieldCopy">{pi}</div>
                                </div>
                            )}
                        </div>

                        <div className="labDetailFieldsRight">
                            <div className="labDetailField">
                                <div className="labDetailFieldTitle">Shipping Address</div>
                                <div className="labDetailFieldAddress">
                                    {address1 && <p>{address1}</p>}
                                    {address2 && <p>{address2}</p>}
                                    {address3 && <p>{address3}</p>}
                                    {address4 && <p>{address4}</p>}
                                    <p>{city}, {state} {postalCode}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </Paper>
            )}
        </>
    );
};

export default LabsDetails;
